<script>
import con from '@services/connection'
import { tarefasDia } from '@constants/URL'
import Title from '@components/section-title'
import rules from '@constants/Rules'
import Vue from 'vue'
import Task from '@components/config-daily-task'
import store from '@state/store'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'

export default {
  components: {
    Title,
    Task,
  },
  props: {
    bus: {
      type: Object,
      default: null,
      required: true,
    },
  },
  data() {
    return {
      busModal: new Vue(),
      loading: false,
      loadingData: false,
      dados: [],
      task_type: '',
      tarefa: {
        campo_parametro: '', // required
        valor_parametro: '', // required
        descricao_parametro: '',
        tipo_dado_parametro: '', // required
        tipo_comparacao_parametro: '', // required
        campo_parametro_v2: '',
        descricao_parametro_2: '',
        valor_parametro_v2: '',
        tipo_dado_parametro_v2: '',
        tipo_comparacao_parametro_v2: '',
        frequencia: 0,
        escala_frequencia: '',
        data_inicio_tarefa: new Date(),
      },
    }
  },
  computed: {
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
    tipoTarefaSelecionada() {
      if (this.task_type) {
        return this.dados.campos_tarefas[this.task_type]
      }
      return {}
    },
  },
  created() {
    this.bus.$on(MODAL.SETTING_DAILY_TASKS, this.open)
  },
  methods: {
    open() {
      this.loadData()
      this.busModal.$emit('dialog', true)
    },
    async loadData() {
      if (this.loadingData) {
        return
      }
      this.loadingData = true
      const r = await con.get(tarefasDia.tasks)
      this.dados = r.value
      this.loadingData = false
    },
    async salvar() {
      console.log('salvar')
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" max-width="1200px">
    <Title title="Configurar tarefas do dia" />

    <div>
      <v-row v-if="loadingData" justify="center" align="center">
        <div class="text-center ma-12 w-100">
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-row>
      <div v-else>
        <v-select
          v-model="task_type"
          :items="Object.keys(dados.campos_tarefas || {})"
          label="Tarefa"
        ></v-select>
        <Task
          :campos="tipoTarefaSelecionada"
          :dados="{}"
          :acao="task_type"
          class="elevation-2"
          style="background-color: var(--gray-2); padding: 10px; border-radius: 12px; margin: 10px 0px;"
        />
        <v-row v-if="tipoTarefaSelecionada.campo_parametro" hidden>
          <v-col cols="10" class="d-flex align-baseline">
            <p>Tarefa para verificar se o campo</p>
            <v-select
              class="ml-2"
              :items="tipoTarefaSelecionada.campo_parametro"
              label="Campo Parametro"
            >
            </v-select>
          </v-col>

          <v-col cols="3" class="d-flex align-baseline">
            <p>é</p>
            <v-select
              class="ml-2"
              :items="tipoTarefaSelecionada.tipo_comparacao_parametro"
              label="Tipo comparacao"
            >
            </v-select>
          </v-col>

          <v-col cols="5" class="d-flex align-baseline">
            <v-select
              v-if="tipoTarefaSelecionada.valor_parametro.length"
              class="col-3"
              :items="tipoTarefaSelecionada.valor_parametro"
              label="Valor parametro"
            ></v-select>
            <v-text-field v-else label="Valor parametro"> </v-text-field>
            <p> ( {{ tipoTarefaSelecionada.tipo_dado_parametro[0] }} ) </p>
          </v-col>

          <!-- <v-select
              class="col-3"
              :items="t.tipo_dado_parametro"
              label="Tipo dado"
            >
              <template v-slot:prepend>
                (
              </template>
              <template v-slot:append>
                )
              </template>
            </v-select> -->
        </v-row>
        <v-row v-if="tipoTarefaSelecionada.campo_parametro_v2" hidden>
          <v-col cols="10" class="d-flex align-baseline">
            <p> Considerando que o campo </p>
            <v-select
              class="ml-2"
              :items="tipoTarefaSelecionada.campo_parametro_v2"
              label="Campo Parametro 2"
            ></v-select>
          </v-col>

          <v-col cols="3" class="d-flex align-baseline">
            <p> é </p>
            <v-select
              class="ml-2"
              :items="tipoTarefaSelecionada.tipo_comparacao_parametro_v2"
              label="Tipo comparacao 2"
            ></v-select>
          </v-col>

          <v-col cols="5" class="d-flex align-baseline">
            <v-select
              v-if="tipoTarefaSelecionada.valor_parametro_v2.length"
              :items="tipoTarefaSelecionada.valor_parametro_v2"
              label="Valor parametro 2"
            ></v-select>
            <v-text-field v-else label="Valor parametro 2" class="mr-2">
            </v-text-field>
            ( {{ tipoTarefaSelecionada.tipo_dado_parametro_v2[0] }} )
          </v-col>

          <!-- <v-select
              class="col-3"
              :items="t.tipo_dado_parametro_v2"
              label="Tipo dado 2"
            ></v-select> -->
        </v-row>
        <hr />

        <div v-for="(t, i) in dados.campos_tarefas" hidden>
          <small>{{ t }}</small>
          <small style="color: red;">{{ i }}</small>

          <v-row v-if="t.campo_parametro">
            <v-col cols="10" class="d-flex align-baseline">
              <p>Tarefa para verificar se o campo</p>
              <v-select
                class="ml-2"
                :items="t.campo_parametro"
                label="Campo Parametro"
              >
              </v-select>
            </v-col>

            <v-col cols="3" class="d-flex align-baseline">
              <p>é</p>
              <v-select
                class="ml-2"
                :items="t.tipo_comparacao_parametro"
                label="Tipo comparacao"
              >
              </v-select>
            </v-col>

            <v-col cols="5" class="d-flex align-baseline">
              <v-select
                v-if="t.valor_parametro.length"
                class="col-3"
                :items="t.valor_parametro"
                label="Valor parametro"
              ></v-select>
              <v-text-field v-else label="Valor parametro"> </v-text-field>
              <p> ( {{ t.tipo_dado_parametro[0] }} ) </p>
            </v-col>

            <!-- <v-select
              class="col-3"
              :items="t.tipo_dado_parametro"
              label="Tipo dado"
            >
              <template v-slot:prepend>
                (
              </template>
              <template v-slot:append>
                )
              </template>
            </v-select> -->
          </v-row>
          <v-row v-if="t.campo_parametro_v2">
            <v-col cols="10" class="d-flex align-baseline">
              <p> Considerando que o campo </p>
              <v-select
                class="ml-2"
                :items="t.campo_parametro_v2"
                label="Campo Parametro 2"
              ></v-select>
            </v-col>

            <v-col cols="3" class="d-flex align-baseline">
              <p> é </p>
              <v-select
                class="ml-2"
                :items="t.tipo_comparacao_parametro_v2"
                label="Tipo comparacao 2"
              ></v-select>
            </v-col>

            <v-col cols="5" class="d-flex align-baseline">
              <v-select
                v-if="t.valor_parametro_v2.length"
                :items="t.valor_parametro_v2"
                label="Valor parametro 2"
              ></v-select>
              <v-text-field v-else label="Valor parametro 2" class="mr-2">
              </v-text-field>
              ( {{ t.tipo_dado_parametro_v2[0] }} )
            </v-col>

            <!-- <v-select
              class="col-3"
              :items="t.tipo_dado_parametro_v2"
              label="Tipo dado 2"
            ></v-select> -->
          </v-row>
          <hr />
          <br /><br />
        </div>

        <div v-for="t in dados.dados_tarefa">
          <Task
            :campos="dados.campos_tarefas[t.nome_funcao]"
            :dados="t"
            :acao="t.nome_funcao"
            class="elevation-2"
            style="background-color: var(--gray-2); padding: 10px; border-radius: 12px; margin: 15px 0px;"
          />
          <small hidden>
            {{ t }}
            <p> {{ t.acao }} </p>
            <p> {{ t.descricao }} </p>
            <p> {{ t.descricao_parametro }} </p>
            <p> {{ t.descricao_parametro_2 }} </p>
          </small>
          <v-row hidden>
            <label>
              Executada a cada {{ t.frequencia }} {{ t.escala_frequencia }}
            </label>
            <!-- <v-text-field
              label="Frequencia"
              class="col-2"
              :value="t.frequencia"
            >
            </v-text-field> -->

            <!-- <v-select
              class="col-3"
              :items="[t.escala_frequencia]"
              label="Escala frequencia"
            ></v-select> -->
          </v-row>
          <v-row v-if="t.campo_parametro" hidden>
            <label>
              Tarefa para verificar se o campo {{ t.campo_parametro }} é
              {{ t.tipo_comparacao_parametro }} {{ t.valor_parametro }} (
              {{ t.tipo_dado_parametro }})
            </label>
            <!-- <v-select
              class="col-3"
              :items="[t.campo_parametro]"
              label="Campo Parametro"
            ></v-select> -->
            <!-- <v-select
              class="col-3"
              :items="[t.tipo_comparacao_parametro]"
              label="Tipo comparacao"
            ></v-select> -->
            <!-- <v-select
              v-if="t.valor_parametro.length"
              class="col-3"
              :items="[t.valor_parametro]"
              label="Valor parametro"
            ></v-select>
            <v-text-field v-else label="Valor parametro"> </v-text-field> -->
            <!-- <v-select
              class="col-3"
              :items="[t.tipo_dado_parametro]"
              label="Tipo dado"
            ></v-select> -->
          </v-row>
          <v-row v-if="t.campo_parametro_v2" hidden>
            <label>
              Contanto que {{ t.campo_parametro_v2 }} seja
              {{ t.tipo_comparacao_parametro_v2 }} {{ t.valor_parametro_v2 }} (
              t.tipo_dado_parametro_v2 )
            </label>
            <!-- <v-select
              class="col-3"
              :items="[t.campo_parametro_v2]"
              label="Campo Parametro 2"
            ></v-select> -->
            <!-- <v-select
              class="col-3"
              readonly
              :value="[t.tipo_comparacao_parametro_v2]"
              label="Tipo comparacao 2"
            ></v-select> -->

            <!-- <v-select
              v-if="t.valor_parametro_v2.length"
              class="col-3"
              :items="t.valor_parametro_v2"
              label="Valor parametro 2"
            ></v-select>
            <v-text-field
              v-else
              label="Valor parametro 2"
              :value="t.valor_parametro_v2"
            >
            </v-text-field> -->

            <!-- <v-select
              class="col-3"
              :items="[t.tipo_dado_parametro_v2]"
              label="Tipo dado 2"
            ></v-select> -->
          </v-row>
          <!-- <hr /> -->
          <!-- <br /><br /> -->
        </div>
      </div>
    </div>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close">
        Cancelar
      </BaseButton>
      <BaseButton primary :loading="loading" @click="salvar">
        Salvar
      </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>


